export default __webpack_public_path__ + "static/media/carrosel02.505960f9.png";